import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 34;

const Bracket10: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%', minWidth: 1124 }}>
            <Grid columns="repeat(7, max-content)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '6 / 8' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 12' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>


                    {/* Losers Heading */}
                    <Cell style={{ gridRow: '23 / 23' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    {/* Losers */}
                    <Cell style={{ gridRow: '25 / 27' }}>
                        <Game game={games[6]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '29 / 31' }}>
                        <Game game={games[7]} topLabel bottomLabel/>
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[2]} topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[3]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '9 / 11' }}>
                        <Game game={games[4]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 15' }}>
                        <Game game={games[5]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}
                    <Cell style={{ gridRow: '19 / 21' }} align="center" justify="flex-end" pe="lg">
                        <H2 font="leader" align="right" className={style.bracketHeading} color="primary">TOILET BOWL</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '26 / 28' }}>
                        <Game game={games[10]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '30 / 32' }}>
                        <Game game={games[11]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[8]} />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 14' }}>
                        <Game game={games[9]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '17 / 19' }} bgColor="tertiary200" >
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    <Cell style={{ gridRow: '19 / 21' }} bgColor="tertiary200" >
                    </Cell>

                    <Cell style={{ gridRow: '21 / 23' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '27 / 29' }}>
                        <Game game={games[12]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '31 / 33' }}>
                        <Game game={games[13]} bottomLabel/>
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '4 / 12' }}>
                        <Game game={games[14]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '17 / 18' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '18 / 22' }} bgColor="tertiary200">
                        <Game game={tbGames[2]} />
                    </Cell>
                    <Cell style={{ gridRow: '22 / 23' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '28 / 32' }}>
                        <Game game={games[15]} />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '8 / 8' }}>
                        <ByGame />
                    </Cell>

                    {/* TB Winner */}

                    <Cell style={{ gridRow: '17 / 20' }} bgColor="tertiary200" width="100px" />
                    <Cell style={{ gridRow: '20 / 20' }} bgColor="tertiary200" width="100px">
                        <ByGame tb color="black" />
                    </Cell>
                    <Cell style={{ gridRow: '21 / 23' }} bgColor="tertiary200" width="100px" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '30 / 34' }}>
                        <Game game={games[16]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '8 / 32' }}>
                        <Game game={games[17]} />
                    </Cell>
                </Grid>
                {/* Round 7 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '20 / 22' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>

                    <Cell style={{ gridRow: '22 / 24' }}>
                        <Game game={games[18]} />
                    </Cell>
                </Grid>

                {games[17].winner && games[17].team2.id === games[17].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '16 / 26' }} width="260px">
                            <Game game={games[18]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '20 / 22' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket10;
